/**
 * Shared rules for surfacing NYSCEF foreclosure cases (`nyscef-cases-foreclosures`).
 *
 * A "Lis Pendens" badge is a claim that the property is under an active foreclosure action, so the
 * case has to still be open for it to be true. These stages mean the action ended:
 *
 *   discontinued — plaintiff withdrew it (borrower cured, refinanced, or settled)
 *   dismissed    — court threw it out
 *   satisfied    — the debt was paid
 *
 * This matters more than it looks: `discontinued` is the single largest stage in the core, 9,832 of
 * 22,204 cases (44%), so an unfiltered badge is wrong nearly half the time.
 *
 * `sale_held` is deliberately NOT in this list. The auction happened and the case is effectively
 * over, but the property changed hands through foreclosure, which is worth surfacing. Add it here
 * if the badge should mean "pending action" strictly.
 */
export const FORECLOSURE_CLOSED_STAGES = ['discontinued', 'dismissed', 'satisfied'];

/** Solr `fq` clause that keeps closed cases out of the enrichment queries feeding the badges. */
export const FORECLOSURE_ACTIVE_FQ = `-case_stage:(${FORECLOSURE_CLOSED_STAGES.join(' OR ')})`;

/** Render-time guard, for cases already fetched without the filter above. */
export const _isForeclosureActive = (fc) =>
  !!fc && FORECLOSURE_CLOSED_STAGES.indexOf(String(fc.case_stage || '').toLowerCase()) < 0;
